// Constantes compartidas del modulo Seguimiento y recurrencia de tratamientos.

export const BUCKET_LABELS = {
  upcoming: 'Por vencer',
  overdue: 'Vencida',
  at_risk: 'En riesgo',
};

// Paleta coherente con la identidad earthy/luxury de la clínica, en orden
// creciente de urgencia (ambar -> naranja -> rojo).
export const BUCKET_COLORS = {
  upcoming: { bg: '#FBEFD9', text: '#9A6B22' },
  overdue: { bg: '#F6E2C8', text: '#B5691F' },
  at_risk: { bg: '#F4E1E1', text: '#A34B49' },
};

export const FOLLOWUP_STATUS_LABELS = {
  pending: 'Pendiente',
  contacted: 'Contactada',
  postponed: 'Pospuesta',
  discarded: 'Descartada',
  completed: 'Completada',
};

export const FOLLOWUP_STATUS_COLORS = {
  pending: { bg: '#EFEDE8', text: '#6B5D50' },
  contacted: { bg: '#DCEEF0', text: '#2E6B75' },
  postponed: { bg: '#E8DFD8', text: '#6B5D50' },
  discarded: { bg: '#EFEDE8', text: '#948A7C' },
  completed: { bg: '#E3EDE1', text: '#4C6947' },
};

export const EFFECT_DURATION_UNIT_LABELS = { weeks: 'semanas', months: 'meses' };

export function daysOverdueLabel(daysOverdue) {
  if (daysOverdue > 0) return `Vencida hace ${daysOverdue} día${daysOverdue === 1 ? '' : 's'}`;
  if (daysOverdue === 0) return 'Vence hoy';
  const days = Math.abs(daysOverdue);
  return `Vence en ${days} día${days === 1 ? '' : 's'}`;
}

export function formatDateShort(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function toDateInputValue(date) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
